const shouldClearSelectedRows = (rows, selectedRows) => rows.length === selectedRows.length;

export default (state) =>
    Object.assign({}, state, {
        selectedRows: shouldClearSelectedRows(state.rows, state.selectedRows) ? [] : state.rows
    });



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/reducers/selectRows.js